import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BzgModalService, BzgSlideDown } from 'bz-genome-angular';
import { ConnectTriggersService } from '../core/connect-triggers.service';
import { AuthCodeGrantService } from '../auth-code-grant/auth-code-grant.service';
import { MessageService } from '../core/message.service';
import { PendingChangesConnectAlertComponent } from '../modal-actions/connect-pendingchanges.component';
import { Utils } from '../core/trigger.util';

import { ConnectTriggersDetailComponent } from './connect-triggers-detail/connect-triggers-detail.component';
import { DefatultMetaParam } from '../core/TriggerConnection';

@Component({
  selector: 'biz-connect-triggers',
  templateUrl: './connect-triggers.component.html',
  styleUrls: ['./connect-triggers.component.scss'],
  animations: [BzgSlideDown]
})
export class ConnectTriggersComponent implements OnInit {

  triggersConnectionModelType: Array<ITriggerConnectionModelType>;
  selectedTriggerConnection: ITriggerConnection;
  selectedTriggerOriginal: ITriggerConnection;
  isBusy: boolean;  

  redirecUrl: string;
  
  @ViewChild('triggerDetail', { static: false}) triggerDetail: ConnectTriggersDetailComponent;

  constructor(private _modalService: BzgModalService, private _translateService: TranslateService, private authCodeGrantService: AuthCodeGrantService,
    private _connectTriggersService: ConnectTriggersService, private messageService: MessageService) { }

  async ngOnInit() {
    this.isBusy = true;    
    this.redirecUrl = await this.authCodeGrantService.getServerUrl();    
    var promise = this._connectTriggersService.getTriggersConnections();
    promise.then((result) => {
       this.triggersConnectionModelType = result;
       this.triggersConnectionModelType.forEach((item) => {
        item.triggersConnections.sort((a, b) => a.displayName.localeCompare(b.displayName));
      });
      this.isBusy = false;
    });
    promise.catch((result) => {
      this.isBusy = false;
    });
  }

  async selectTriggerConnection(triggerConnection: ITriggerConnection) {
    this.isBusy = true;
    //Load environment
    triggerConnection.environment = await this._connectTriggersService.getTriggersConnectionsEnviron(triggerConnection.id);

    if (this.selectedTriggerConnection && this.triggerDetail?.areThereAnyPendingChanges()) {
      this._showPendingChangesDialog(() => {
        this.saveTriggerConnection();
        this.isBusy = false;
      }, () => {
        this.selectedTriggerOriginal = triggerConnection;
        this.selectedTriggerConnection = Utils.copyObject(triggerConnection);
        this.isBusy = false;
      });
    } else {
      this.selectedTriggerOriginal = triggerConnection;
      this.selectedTriggerConnection = Utils.copyObject(triggerConnection);
      this.isBusy = false;
    }
  }

  public async saveTriggerConnection() {
    if (this.selectedTriggerConnection) {
      this.isBusy = true;
      if (this.isOkCopyMetadataToDataForSave()) {
        if (this.authenticated()) {
          var promise = this._connectTriggersService.saveTriggerConnectionEnviron(this.selectedTriggerConnection);
          promise.then((result) => {
            this._translateService.get('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY').subscribe((message: string) => {
              this.messageService.showSuccess(message);
              Utils.copyDataTrigger(this.selectedTriggerConnection, this.selectedTriggerOriginal);
              this.isBusy = false;
            })
          });
          promise.catch((result) => {
            this.isBusy = false;
          });
        } else {
          this._translateService.get('TRIGGERS.NEED_AUTH').subscribe((message: string) => {
            this.messageService.showError(message);
            this.isBusy = false;
          })
        }
      } else {
        this.isBusy = false;
      }
    }
  }

  authenticated() {
    var currentEnvironment = this.selectedTriggerConnection.environment.currentEnvironment;
    var params = currentEnvironment.params;
    if (currentEnvironment.isEnabled && params.needAuth) {
      if (params && params.tokenCredentials && params.tokenCredentials.accessToken) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  isOkCopyMetadataToDataForSave() {
    if (this.selectedTriggerConnection) {
      var params = this.selectedTriggerConnection.environment.currentEnvironment.params;
      let defaultConfig = new DefatultMetaParam();
      params.authentication = defaultConfig.copyMetaParametersToData(params.metaProperties);
      if (Utils.validateProperties(params.metaProperties, this._translateService, this.messageService)) {
        return true;
      }
    }
    return false;
  }

  public cancelChanges() {
    this.selectedTriggerConnection = null;
  }

  private _showPendingChangesDialog(saveAction: Function, cancelAction: Function) {
    const modal = this._modalService.open(
      PendingChangesConnectAlertComponent,
      { closeOnBackdropClick: false, closeOnRouterNavigation: true }
    );
    modal.afterClosed().subscribe((result: string) => {
      if (result === 'save') {
        saveAction();
      } else {
        cancelAction();
      }
    });
  };
}